import { apiUrl } from 'config/app'
require('es6-promise').polyfill();
require('isomorphic-fetch');
import { startShorten, finishedShorten, failedShorten } from 'actions/shorten';

export const shortenLink = values => {
  return (dispatch, getState) => {

    const { user } = getState();
    values.api_token = user.api_token;

    let headers = new Headers();
    headers.append('Content-Type', 'application/json');


    dispatch(startShorten());

    return fetch(`${apiUrl}/short/v1/link/create`, {
      method: 'POST',
      body: JSON.stringify(values),
      mode: 'cors',
      headers: headers
    })
        .then(response => response.json())
        .then(
            (result) => dispatch(finishedShorten(result)),
            (error) => dispatch(failedShorten(error))
        );
  };

};



// WEBPACK FOOTER //
// ./src/async/shorten.js